import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Lightweight CSS-only tooltip — no Radix dependency.
 * Usage: <Tooltip label="Hello"><button>...</button></Tooltip>
 */
function Tooltip({ label, side = 'bottom', children, className }) {
  return (
    <span className="group/tt relative inline-flex">
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 whitespace-nowrap rounded-md border border-border bg-popover px-2 py-1 text-xs text-popover-foreground shadow-md opacity-0 transition-opacity duration-150 group-hover/tt:opacity-100',
          side === 'bottom' && 'top-full left-1/2 mt-2 -translate-x-1/2',
          side === 'top' && 'bottom-full left-1/2 mb-2 -translate-x-1/2',
          side === 'right' && 'left-full top-1/2 ml-2 -translate-y-1/2',
          side === 'left' && 'right-full top-1/2 mr-2 -translate-y-1/2',
          className
        )}
      >
        {label}
      </span>
    </span>
  );
}

export { Tooltip };
